module.exports = __webpack_public_path__ + "static/devicepresets-16f98d13dbc1c239fba573d74729cfe6.png";